import { z } from "zod";
import { ECompanyInformationSection, schemes } from "@zeal/common";

export const postGenerateCompanyShareableLinkSchema = z.object({
  companyID: schemes.companyID(),
  section: z.nativeEnum(ECompanyInformationSection),
  send_to_admin: z.boolean().optional(),
});

export type TPostGenerateCompanyShareableLinkRequest = z.infer<
  typeof postGenerateCompanyShareableLinkSchema
>;
